import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

// Utilitaire pour lire une variable CSS
function getCssVar(name) {
  return getComputedStyle(document.documentElement).getPropertyValue(name).trim();
}

// Détection mobile via breakpoints CSS
function isMobileViewport() {
  const bp = getCssVar('--breakpoints-tablet');
  return window.matchMedia(`(max-width: ${bp})`).matches;
}

// Swiper : gestion des instances
const swiperInstances = new Map();

function initTabsCarousels() {
  const carousels = document.querySelectorAll('.wp-block-o-tabs-carousel');

  carousels.forEach((carousel, index) => {
    const container = carousel.querySelector('.tabs-items');
    if (!container) return;

    const id = carousel.dataset.carouselId || `carousel-${index}`;
    const isMobile = isMobileViewport();
    const existingInstance = swiperInstances.get(id);

    if (isMobile && !existingInstance) {
      const paginationEl = carousel.querySelector('.swiper-pagination');
      if (!paginationEl) return;

      const instance = new Swiper(container, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        allowTouchMove: true,
        pagination: {
          el: paginationEl,
          clickable: true,
        },
        on: {
          slideChange(swiper) {
            updateActiveTabButton(carousel, swiper.realIndex);
          },
        },
      });

      // Corrige les slides cachés hérités du mode desktop
      const slides = container.querySelectorAll('.swiper-slide');
      slides.forEach(slide => {
        slide.style.removeProperty('display');
      });

      swiperInstances.set(id, instance);
      updateActiveTabButton(carousel, instance.realIndex); // init label
    }

    if (!isMobile && existingInstance) {
      existingInstance.destroy(true, true);
      swiperInstances.delete(id);
    }
  });
}

function updateActiveTabButton(carousel, index) {
  if (!carousel.dataset.sliderTitle) return;

  const buttons = carousel.querySelectorAll('.tabs-list-item');
  buttons.forEach(btn => btn.classList.remove('is-active'));

  const activeBtn = carousel.querySelector(`.tabs-list-item[data-tab="${index}"]`);
  if (activeBtn) {
    activeBtn.classList.add('is-active');
  }
}

function initTabsDesktop() {
  const carousels = document.querySelectorAll('.wp-block-o-tabs-carousel');

  if (isMobileViewport()) return;

  carousels.forEach((carousel) => {
    const tabs = carousel.querySelectorAll('.tabs-list-item');
    const items = carousel.querySelectorAll('.tabs-item');

    tabs.forEach((tabBtn) => {
      tabBtn.addEventListener('click', () => {
        const tabIndex = tabBtn.dataset.tab;

        tabs.forEach(t => t.classList.remove('is-active'));
        items.forEach(i => {
          i.classList.remove('is-active');
          i.style.display = 'none';
        });

        tabBtn.classList.add('is-active');
        const activeItem = carousel.querySelector(`.tabs-item[data-tab="${tabIndex}"]`);
        if (activeItem) {
          activeItem.style.display = 'block';
          void activeItem.offsetWidth;
          activeItem.classList.add('is-active');
        }
      });
    });
  });
}

// Initialisation
let wasMobile = isMobileViewport();

window.addEventListener('load', () => {
  initTabsDesktop();
  initTabsCarousels();
});

window.addEventListener('resize', () => {
  const isMobile = isMobileViewport();

  if (isMobile !== wasMobile) {
    initTabsDesktop();
    initTabsCarousels();
  }

  wasMobile = isMobile;
});
